import { render, staticRenderFns } from "./MainViewAdmin.vue?vue&type=template&id=24f728cc&"
import script from "./MainViewAdmin.vue?vue&type=script&lang=js&"
export * from "./MainViewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MainViewAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports